export class DialogMapAdjustment {
  constructor(public data: any) {}
}
